import { Component, ChangeDetectionStrategy, ElementRef, Input } from '@angular/core';

import { SnBaseButtonComponent } from '../../base/base-button.component';

@Component({
  selector: 'sn-icon-button',
  templateUrl: './icon-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: ['disabled', 'color', 'tabIndex', 'type', 'isLoading'],
  host: {
    class: 'sn-icon-button',
    '[class.loading]': 'isLoadingState',
    '[attr.disabled]': 'isDisabledState',
  },
})
export class SnIconButtonComponent extends SnBaseButtonComponent {
  @Input() public icon: string;
  @Input('aria-label') public ariaLabel: string;

  constructor(elementRef: ElementRef<HTMLElement>) {
    super(elementRef);
  }

  get isDisabledState(): boolean {
    return this.disabled || this.isLoading;
  }

  get isLoadingState(): boolean {
    return this.isLoading && !this.disabled;
  }
}
